import { render, staticRenderFns } from "./AppNativePopupWelcome.vue?vue&type=template&id=08280d44"
import script from "./AppNativePopupWelcome.vue?vue&type=script&lang=js"
export * from "./AppNativePopupWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports